import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\GetPackListForIndexController::__invoke
* @see app/Http/Controllers/Pack/GetPackListForIndexController.php
* @route '/api/pack'
*/
const GetPackListForIndexController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackListForIndexController.url(options),
    method: 'get',
})

GetPackListForIndexController.definition = {
    methods: ["get","head"],
    url: '/api/pack',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Pack\GetPackListForIndexController::__invoke
* @see app/Http/Controllers/Pack/GetPackListForIndexController.php
* @route '/api/pack'
*/
GetPackListForIndexController.url = (options?: RouteQueryOptions) => {
    return GetPackListForIndexController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\GetPackListForIndexController::__invoke
* @see app/Http/Controllers/Pack/GetPackListForIndexController.php
* @route '/api/pack'
*/
GetPackListForIndexController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackListForIndexController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Pack\GetPackListForIndexController::__invoke
* @see app/Http/Controllers/Pack/GetPackListForIndexController.php
* @route '/api/pack'
*/
GetPackListForIndexController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPackListForIndexController.url(options),
    method: 'head',
})

export default GetPackListForIndexController